import { useMutation } from '@tanstack/react-query';

import { request } from '../request';
import { customConditionPdfSchema } from './schemas';

export const usePreviewCustomCondition = (id: number) => {
  return useMutation({
    mutationFn: async () => {
      const response = await request(`/custom-conditions/${id}/pdf`);

      const { pdf } = customConditionPdfSchema.parse(response);

      return pdf;
    },
  });
};
